import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=38857af0&scoped=true"
import script from "./serviceInfo.vue?vue&type=script&lang=js"
export * from "./serviceInfo.vue?vue&type=script&lang=js"
import style0 from "./serviceInfo.vue?vue&type=style&index=0&id=38857af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38857af0",
  null
  
)

export default component.exports